<ng-container *ngIf="appearance==='link'">
  <a [routerLink]="['/report',type,uid]">{{linkText}}</a>
</ng-container>

<ng-container *ngIf="appearance==='button'">
  <a [routerLink]="['/report',type,uid]">
    <app-mat-icon-button [label]="linkText" icon="report"></app-mat-icon-button>
  </a>
</ng-container>
